import React, {FC, ReactElement} from "react";
import {purchaseInvoiceApi} from "../../../backend/PurchaseInvoiceApi";
import FetchPurchaseInvoicesForReviewResponse, {PurchaseInvoicesReviewLine} from "../../../model/invoice/purchase/FetchPurchaseInvoicesForReviewResponse";
import MyMaterialTable from "../../../components/mtable/MyMaterialTable";
import {formatPrice} from "../../../utils/NumberFormat";
import {accountColumn, exportProblemsColumn, prepareDataForReview, reviewDateColumn, reviewTxDateColumn, useInvoiceReview} from "./useInvoiceReview";
import {buildReviewProblemDetails, reviewProblemRowStyle} from "./ReviewProblemDetails";
import {routes} from "../../../main/Routes";

interface IProps {
    taskId?: string,
}

export const ReviewPurchaseInvoices: FC<IProps> = (props): ReactElement => {
    const resultTable = (result: FetchPurchaseInvoicesForReviewResponse) => {
        const align = "center";
        return <MyMaterialTable
                title={`Purchase invoice for the month: ${result.month}`}
                columns={[
                    ...reviewDateColumn<PurchaseInvoicesReviewLine>(),
                    {title: 'Invoice No.', field: 'invoiceNo', align: align},
                    {title: 'Vendor', field: 'vendorName', align: align},
                    {title: 'Inv total', render: (data) => formatPrice(data.invoiceTotal, data.currencyCode), field: 'invoiceTotal', type: 'numeric', align: align},
                    {title: 'Cur', field: 'currencyCode', align: align},
                    {title: 'Paid amt', render: (data) => formatPrice(data.paidAmount, data.currencyCode), field: 'paidAmount', type: 'numeric', align: align},
                    ...reviewTxDateColumn<PurchaseInvoicesReviewLine>(),
                    // {title: 'Description', field: 'lineDescription', align: align},
                    ...accountColumn,
                    {title: 'Amount', render: (data) => formatPrice(data.amountExclVat, data.currencyCode), field: 'amountExclVat', type: 'numeric', align: align},
                    {title: 'VAT amt', render: (data) => formatPrice(data.vatAmount, data.currencyCode), field: 'vatAmount', type: 'numeric', align: align},
                    {title: 'VAT', field: 'vatName', align: align},
                    {title: 'VAT No', field: 'vatNo', align: align},
                    {title: 'Country', field: 'countryName', align: align},
                    {title: 'Vat accountable', field: 'vatAccountable', type: 'boolean', align: align},
                    exportProblemsColumn,
                ]}
                data={prepareDataForReview(result.lines)}
                detailPanel={[(rowData => buildReviewProblemDetails(rowData.problems))]}
                options={{
                    rowStyle: (data) => reviewProblemRowStyle(data.problems),
                    search: true,
                    sorting: true,
                    paging: false,
                    draggable: false,
                    selection: false,
                    maxBodyHeight: "calc(100vh - 12rem)",
                    exportButton: {csv: true, pdf: false},
                    exportDelimiter: ";",
                }}
        />;

    }

    const params = {
        initTaskId: props.taskId,
        route: routes.reviewPurchaseInvoicesTaskId,
        api: purchaseInvoiceApi,
        renderResults: resultTable
    };
    return useInvoiceReview(params)
};